import WorkersBanner from './WorkersBanner';

export default WorkersBanner;
